import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ClinicInfo } from 'src/app/clinic/ClinicInfo';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  private orgApiUrl = environment.apibaseUrl + '/organization';
  private userApiUrl = environment.apibaseUrl + '/user';
  private roleApiUrl = environment.apibaseUrl + '/role';

  constructor(private http: HttpClient) {
  }

  saveClinic(clinicInfo: ClinicInfo) {
    return this.http.post(this.orgApiUrl + '/clinic', clinicInfo);
  }

  deleteClinic(clinicId: number) {
    return this.http.delete(this.orgApiUrl + '/clinic/?clinicId=' + clinicId);
  }

  getAssosiateAppointmenttypeList(clinicId: number) {
    return this.http.get(this.orgApiUrl + '/assosiateappointmenttype/?clinicId=' + clinicId);
  }

  getClinicList() {
    return this.http.get(this.orgApiUrl + '/clinic');
  }

  getClinicListByUserId(clientId) {
    return this.http.get(this.orgApiUrl + '/clinicList/?clientId=' + clientId);
  }

  getClinicInfo(id: number) {
    return this.http.get(this.orgApiUrl + '/clinic/' + id);
  }

  getUserList(firstname: string, lastname: string, role: string, status: string) {
    const formdata = new FormData();
    formdata.append('firstname', firstname);
    formdata.append('lastname', lastname);
    formdata.append('role', role.toString());
    formdata.append('status', status);
    return this.http.post(this.userApiUrl + '/list', formdata);
  }

  getdeletedUserList(firstname: string, lastname: string, role: string, status: string) {
    const formdata = new FormData();
    formdata.append('firstname', firstname);
    formdata.append('lastname', lastname);
    formdata.append('role', role.toString());
    formdata.append('status', status);
    return this.http.post(this.userApiUrl + '/deleted/list', formdata);
  }

  getApplicationRole() {
    return this.http.get(this.roleApiUrl);
  }

  getClientAppointmentBook() {
    return this.http.get(this.orgApiUrl + '/clientAppointmentBooking');
  }

}
